import React from 'react';
import '../assets/welcome.scss';
import {CONTACT_US_URL, MARKETING_URL} from 'src/constants/Links';

interface WelcomePageProps {
    // Unused while self-service onboarding is deprecated; kept so the flow can be re-enabled.
    onGetStarted?: () => void;
}

const WelcomePage: React.FC<WelcomePageProps> = () => {
    return (
        <div className="heading-section">
            <h1>
                <span className="welcome-heading">Welcome to </span>
                <span className="started">Amazon Autos</span>
            </h1>
            <p className="welcome-text">Thank you for your interest in selling on Amazon Autos.</p>
            <p className="welcome-text-disclaimer">Please contact us for next steps, or visit autos.amazon to learn more about Amazon Autos.</p>
            <div className="welcome-actions">
                <a className="welcome-marketing-link" href={MARKETING_URL}>Visit autos.amazon</a>
                <a className="welcome-contact-button" href={CONTACT_US_URL}>Contact us</a>
            </div>
        </div>
    );
};

export default WelcomePage;
